<template>
  <div>
    <div class="contactFooter">
      <h1 class="ContactToday">Contact us today</h1>
      <p class="email">
        info@intextelectric.ca <br />
        <a href="tel:+15879695387" style="text-decoration:none; color:white"
          >(587) 969-5387</a
        >
      </p>
      <button class="contact-button" @click="popup">
        Contact for Free Quote
      </button>
    </div>
    <div class="footer">
      <div class="siteInfo">
        <div class="siteMap">
          <h4>Site Map</h4>
          <br />
          <router-link class="context" to="/">HOME</router-link>
          <router-link class="context" to="/residential"
            >RESIDENTIAL SERVICES</router-link
          >
          <router-link class="context" to="/commercial"
            >COMMERCIAL SERVICES</router-link
          >
          <router-link class="context" to="/projects">PROJECTS</router-link>
          <router-link class="context" to="/about">ABOUT</router-link>
        </div>

        <div class="services">
          <h4>Services</h4>
          <div class="provided">
            <h5>
              > Led lighting upgrades
              <br />> Panel upgrades <br />> Electrical troubleshooting <br />>
              Home automation <br />> Residential <br />> Commercial <br />> New
              build
            </h5>
            <h5>
              > Renovations
              <br />> Service calls <br />> Fan retrofit <br />> And more ...
              <br />
              <br />
              <br />
              Business Licence: BL226174
            </h5>
          </div>
        </div>
        <div class="Customer">
          <img
            src="../assets/sert5.png"
            alt=""
            height="170px"
            width="125px"
            class="sertLogo"
          />
        </div>
      </div>
      <h6>Copyright © 2023 INTEXT ELECTRIC</h6>
      <p>
        The information on this website is for informational purposes only; it
        is deemed accurate but not guaranteed. It does not constitute
        professional advice. All information is subject to change at any time
        without notice. Contact us for complete details.
      </p>
    </div>
    <div id="popup1" class="overlay">
      <div class="popup">
        <h2>Send a message</h2>
        <a class="close" id="close" @click="close">&times;</a>
        <div class="content">
          <div class="contactForm">
            <input
              type="name"
              class="contactInp"
              placeholder="   Full Name"
              v-model="FullName"
            />
            <input
              type="email"
              class="contactInp"
              placeholder="   Email"
              v-model="Email"
            />
            <input
              type="phone"
              class="contactInp"
              placeholder="   Phone"
              v-model="Phone"
            />
            <input
              type="company"
              class="contactInp"
              placeholder="   Company"
              v-model="Company"
            />
            <textarea
              class="bubble-element MultiLineInput"
              data-gramm_editor="false"
              placeholder="Your questions..."
              maxlength=""
              style=" height: 100px; border: 1px solid black; 
                background-color: rgb(255, 255, 255); border-radius: 16px; 
                font-size: 16px; color: rgb(0, 0, 0); 
                line-height: 1; padding: 12px 20px; transition: border-color 200ms ease 0s, box-shadow 200ms ease 0s;"
              tabindex="4"
              v-model="Message"
            >
            </textarea>
            <button class="sendBtn" @click="sendEmail">SEND MESSAGE</button>
            <h6>{{ Result }}</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      FullName: "",
      Email: "",
      Phone: "",
      Company: "",
      Message: "",
      Result: "",
    };
  },
  methods: {
    popup() {
      var modal = document.getElementById("popup1");
      modal.style.visibility = "visible";
      console.log("Open");
    },
    close() {
      var modal = document.getElementById("popup1");
      modal.style.visibility = "hidden";
      console.log("Closed");
    },
    sendEmail() {
      axios
        .post("/sendEmail", {
          name: this.FullName,
          company: this.Company,
          email: this.Email,
          phone: this.Phone,
          message: this.Message,
        })
        .then((res) => {
          this.Result = res.data;
        })
        .catch((error) => {
          if (error) {
            this.Result =
              "You can send 1 email every 5 minutes. Please wait a moment.";
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.contactFooter {
  display: flex;
  width: calc(100%-2px);
  height: 65px;
  color: white;
  border: 1px solid black;
  background-color: #012d68ec;
}

.contact-button {
  flex: 2;
  align-self: center;
  margin-right: 25px;
  font-weight: 500;
  font-size: 18px;
  width: 225px;
  height: 50px;
  border: 3px solid #d35400;
  background-color: #014ea5ec;
  color: white;
  cursor: pointer;
}

.contact-button:hover {
  transition: 0.1s;
  transform: scale(1.02);
}

.footer {
  width: 100%;
  height: 350px;
  background-color: rgb(13, 13, 13);
  text-align: center;

  p {
    padding-top: 10px;
    color: rgb(255, 255, 255);
    font-size: 10px;
    margin: auto;
    padding-top: 10px;
  }

  h6 {
    border-top: 0.5px solid rgba(255, 255, 255, 0.671);
    margin: auto;
    color: white;
    padding-top: 10px;
  }

  .context {
    color: rgba(255, 255, 255, 0.822);
    font-size: 12px;
    font-weight: 100;
    float: left;
    text-align: left;
    width: 100%;
    padding: 3px;
    text-decoration: none;
  }

  h5 {
    color: rgba(255, 255, 255, 0.822);
    font-size: 12px;
    font-weight: 100;
    float: left;
    text-align: left;
    width: 100%;
    padding: 3px;
    text-decoration: none;
  }
}

.siteInfo {
  display: flex;
}

.siteMap {
  padding: 50px;
  flex: 1;

  h4 {
    color: white;
    font-size: 16px;
    text-align: left;
  }
}

.services {
  text-align: left;
  flex: 2;
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: left;

  h5 {
    font-size: 16px;
  }

  h4 {
    color: white;
    font-size: 16px;
    text-align: left;
  }

  .provided {
    display: flex;
    flex-direction: row;
    padding-top: 5px;

    p {
      font-weight: 100;
      padding-right: 10px;
      font-size: 15px;
    }
  }
}

.Customer {
  flex: 1;
  display: flex;

  img {
    width: 170px;
    height: 125px;
    align-self: center;
  }
}

.ContactToday {
  flex: 5;
  margin: auto;
  font-size: 25px;
  margin-left: 40px;
}

.email {
  flex: 5;
  margin: auto;
  font-weight: 300;
  text-align: left;
  font-size: 18px;
}

.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 15;
  visibility: hidden;
  opacity: 1;
}

.popup {
  color: #d35400;
  border: 4px solid #013170;
  display: flex;
  z-index: 15;
  flex-direction: column;
  align-items: center;
  margin: 70px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  width: 500px;
  height: 530px;
  position: relative;

  h6 {
    font-size: 10px;
  }
}

.popup h2 {
  margin-top: 0;
  color: #333;
}

.popup .close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 30px;
  font-weight: bold;
  text-decoration: none;
  color: #333;
}

.popup .close:hover {
  cursor: pointer;
  color: #06d85f;
}

.popup .content {
  max-height: 90%;
  overflow: auto;
}

#messageInput {
  height: 90px;
  width: 90%;
}

.contactForm {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  margin-top: 45px;

  .contactInp {
    width: 300px;
    height: 30px;
    margin: 12px;
    border: 1px solid grey;
    border-radius: 18px;
  }

  .sendBtn {
    width: 300px;
    height: 40px;
    margin-top: 25px;
    border: 1px solid rgb(0, 0, 0);
    cursor: pointer;
    background: #fd6c0be1;
    border-radius: 20px;
    color: white;
    font-size: 18px;
    font-weight: bold;
  }

  textarea {
    width: 280px;
  }
}

@media only screen and (max-width: 900px) {
  .contactForm {
    .contactInp {
      width: 250px;
      height: 25px;
      margin: 10px;
      border: 1px solid grey;
      border-radius: 18px;
    }

    .sendBtn {
      width: 250px;
      height: 35px;
      margin-top: 20px;
      border: 1px solid rgb(0, 0, 0);
      cursor: pointer;
      background: #fd6c0be1;
      border-radius: 20px;
      color: white;
      font-size: 18px;
      font-weight: bold;
    }

    textarea {
      width: 230px;
    }
  }

  .popup {
    width: 300px;
  }

  .footer {
    height: 800px;
  }

  .siteInfo {
    flex-direction: column;
  }

  .openingHours {
    padding: 20px;
  }

  .siteMap {
    padding: 20px;
  }

  .services {
    padding: 20px;
  }

  .contactFooter {
    height: 95px;
  }

  .Customer {
    align-self: center;
  }

  .email {
    display: none;
  }

  .contact-button {
    flex: 1.2;
    margin-right: -35px;
    transform: translateX(-50%);
  }

  .ContactToday {
    flex: 3;
    font-size: 23px;
  }
}
</style>
